import axiosInstance from "@/api/axiosInstance";
import type { OfferItem } from "@/components/types";

export class OfferService {
  public async createOffer(
    accommodationId: string,
    offerItems: OfferItem[],
    cancellationPolicy: string,
    comment: string
  ): Promise<any> {
    const url = `/api/v1/admin/inquiry/${accommodationId}/offers/create`;
    const offerObject = [
      {
        items: offerItems,
        cancellationPolicy,
        comment,
      },
    ];

    await axiosInstance.post(url, offerObject);
  }

  /** Rewrites a draft in place; the backend rejects anything that is no longer a draft. */
  public async updateDraftOffer(
    offerId: number,
    offerItems: OfferItem[],
    cancellationPolicy: string,
    comment: string
  ): Promise<any> {
    const url = `/api/v1/admin/offer/${offerId}`;
    await axiosInstance.put(url, {
      items: offerItems,
      cancellationPolicy,
      comment,
    });
  }

  public async publishOffers(
    inquiryId: string,
    offerIds: number[]
  ): Promise<any> {
    const url = `/api/v1/admin/inquiry/${inquiryId}/offers/publish`;
    await axiosInstance.put(url, { offerIds });
  }

  public async deleteDraftOffer(offerId: number): Promise<any> {
    const url = `/api/v1/admin/offer/${offerId}`;
    await axiosInstance.delete(url);
  }

  public async acceptOffer(offerId: number): Promise<any> {
    const url = `/api/v1/offer/${offerId}/accept`;
    await axiosInstance.put(url);
  }

  /** Turns down a single offer; the backend rejects anything that is not still pending. */
  public async declineOffer(offerId: number): Promise<any> {
    const url = `/api/v1/offer/${offerId}/decline`;
    await axiosInstance.put(url);
  }

  public async adminAcceptOffer(offerId: number): Promise<any> {
    const url = `/api/v1/admin/offer/${offerId}/accept`;
    await axiosInstance.put(url);
  }
}
